import('@angular/platform-browser');

import('./bootstrap').catch((err) => {
  console.error(err);
});
